import React from "react";
import { PageHeader } from "./Rentals";

export default function Terms() {
  return (
    <div>
      <PageHeader eyebrow="Legal" title="Terms & Conditions" subtitle="Clear booking, payment, and service terms for IceFleet customers." />
      <section className="mx-auto max-w-4xl px-5 sm:px-8 pb-24 space-y-10 text-sm leading-7 text-slate-700">
        <LegalSection title="Bookings">
          <p>Bookings may be confirmed from same-day service up to 90 days before service delivery depending on availability and service type.</p>
          <p>All bookings are subject to vehicle, driver, and service availability at the time of confirmation.</p>
        </LegalSection>
        <LegalSection title="Payments">
          <p>Fixed-price website bookings must be paid in full before they are confirmed unless otherwise stated. Quote-required and manually managed bookings may be invoiced separately.</p>
        </LegalSection>
        <LegalSection title="Cancellations & Refunds">
          <p>Cancellation and refund handling depends on service type, notice period, and supplier commitments. Please refer to the Refund Policy for operational rules.</p>
        </LegalSection>
        <LegalSection title="Service delivery">
          <p>Pickup times, estimated durations, and routing may be affected by traffic, weather, road closures, flight changes, or operational safety constraints.</p>
        </LegalSection>
        <LegalSection title="Liability & no-show">
          <p>IceFleet is not liable for indirect losses, missed connections, or delays caused by circumstances outside reasonable operational control. No-shows may be treated as fully chargeable unless otherwise agreed in writing.</p>
        </LegalSection>
        <LegalSection title="Vehicle / rental responsibility">
          <p>Customers renting or using IceFleet vehicles are responsible for complying with agreed operating terms, lawful use, and any documented vehicle handover conditions.</p>
        </LegalSection>
        <LegalSection title="Governing law">
          <p>These services are governed by Icelandic law and jurisdiction.</p>
        </LegalSection>
      </section>
    </div>
  );
}

function LegalSection({ title, children }) {
  return (
    <div className="space-y-3">
      <h2 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">{title}</h2>
      <div className="space-y-3">{children}</div>
    </div>
  );
}